import React, { FC } from 'react'

const CurvyLine: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="369"
    height="980"
    viewBox="0 0 369 980"
    fill="none"
  >
    <path
      stroke="#71757D"
      strokeDasharray="14 14"
      strokeLinecap="round"
      strokeOpacity=".5"
      strokeWidth="2"
      d="M192.98 900.5c-22.725 28.358-56.631 50.43-86.48 77.928M307 362c22.5 19 58.5 80 60 197.5s-25 166.5-60 215M1.03 1C-.712 95.876 73.443 145.253 105 176"
    />
  </svg>
)

export default CurvyLine
